import React from 'react';
import { useTheme } from '../../context/theme-context';

interface BaseSkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular' | 'rounded';
  width?: string | number;
  height?: string | number;
  animation?: 'pulse' | 'wave' | 'none';
}

const BaseSkeleton: React.FC<BaseSkeletonProps> = ({
  className = '',
  variant = 'text',
  width,
  height,
  animation = 'pulse',
}) => {
  const { isDarkMode } = useTheme();

  const baseStyles = {
    backgroundColor: isDarkMode ? '#374151' : '#e5e7eb', // ✅ Dark mode: gray-700, Light: gray-200
    width: width || (variant === 'text' ? '100%' : 'auto'),
    height: height || (variant === 'text' ? '1em' : variant === 'circular' ? '40px' : '100%'),
  };

  const variantStyles = {
    text: 'rounded',
    circular: 'rounded-full',
    rectangular: 'rounded-none',
    rounded: 'rounded-lg',
  };

  const animationStyles = {
    pulse: 'animate-pulse',
    wave: 'relative overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:bg-gradient-to-r before:from-transparent before:via-white/20 before:to-transparent before:animate-[shimmer_1.5s_infinite]',
    none: '',
  };

  return (
    <div
      className={`${variantStyles[variant]} ${animationStyles[animation]} ${className}`}
      style={baseStyles}
    />
  );
};

export default BaseSkeleton;